<template>
    <div id="records">
        <div id="headers">
            <i class="arr" @click="goBack()"></i>
            <p class="title">{{title}}</p>
            <form :action="formUrl" method="post" ref="tbForm">
                <a href="javascript:;" class="addGlbtn" @click="intoaddMsg">添加 |</a>
                <button type="button" class="subBtn" @click="reportTable">导出</button>
            </form>
        </div>
        <div class="listBox">
            <!-- <form method="post" action=""  onsubmit="return false;">
                <div class="inputBox">
                    <input type="search" class="ipt" placeholder="搜索住户" v-model="value" @keyup="searchVal" autofocus ref="keyIpt">
                </div>
            </form> -->
            <div class="ttsearchBox">
                <input type="search" class="ipt ttipt" v-model="keyword" placeholder="输入姓名、手机、公司搜索" ref="keyIpt" @keyup="searchVal">
            </div>
            <div class="setFix"></div>
            <p class="wranTop">请严格保护用户隐私，禁止任何形式的非法复制、传播和使用用户信息</p>
            <!-- <div class="selectBox">
                <div class="select-item clearfix">
                    <div class="allStatus">
                        <select name="" id="">
                            <option value="">全部状态</option>
                            <option value="">待审核</option>
                            <option value="">已通过</option>
                        </select>
                    </div>
                    <div class="allCards">
                        <select name="" id="">
                            <option value="">全部身份</option>
                            <option value="">业主</option>
                            <option value="">租户</option>
                            <option value="">公司</option>
                        </select>
                    </div>
                </div>
            </div> -->
            <div class="item-list" v-for="(item,i) in lists" :key="i" @click="intoDetail(item.openId,item._id)">
                <div class="top">
                    <div class="left">{{item.name}}{{item.owner?'（'+item.owner+'）':''}}</div>
                    <div class="right">{{item.created_at}}</div>
                </div>
                <div class="btm">
                    <span class="phone">{{item.mobile}}</span>
                    <a href="javascripot:;" class="sstate" :class="item.status=='1'?'astate':''">{{item.status=='1'?'已通过':'待审核'}}</a>
                    <!-- <a href="javascripot:;" class="sstate astate">已通过</a> -->
                </div>
            </div>
        </div>
         <!-- v-show="noShow && jsLists.length == 0" -->
        <div class="noLists" v-show="noShow && lists.length == 0">
            <img src="~@/assets/imgs/bg.png" alt />
            <p>暂无数据~</p>
        </div>
        <div class="setH"></div>
        <div class="btmBox">
            <mt-button type="danger" class="btBtn btBtn3" @click="goIndex">管理中心</mt-button>
            <mt-button type="danger" class="btBtn" :class="isnum==1?'active':''" @click="changeStatus(1)">待审核({{len1}})</mt-button>
            <mt-button type="danger" class="btBtn btBtn2" :class="isnum==2?'active':''" @click="changeStatus(2)">已通过({{len2}})</mt-button>
            <mt-button type="danger" class="btBtn" :class="isnum==3?'active':''" @click="changeStatus(3)">全部({{len3}})</mt-button>
        </div>
        <!-- 弹层遮罩 -->
        <div class="bigMask" v-show="showMask" @click="closeMask">
            <p class="one">1、点击右上角“...”</p>
            <p>2、选择“在浏览器打开”后即可导出记录</p>
            <img src="@/assets/imgs/arrow.png" alt="">
        </div>
    </div>
</template>
<script>
import Top from "@/component/top/top";
import axios from 'axios'
import { Indicator, Toast } from 'mint-ui';
export default {
    components:{
        Top
    },
    data() {
        return {
            title:'登记记录',
            isnum:1,
            value:'',
            lists:[],
            noShow:false,
            formUrl:null,
            len1:0,
            len2:0,
            len3:0,
            showMask:false,
            keyword:''
        }
    },
    mounted() {
        // this.setuserToken('wr7w4pRzr4pK8a5ZC090rM8K7Jm95Acz')
        // this.getLists(1)
        axios.post(this.commonIp()+'/v1/mobile/community/userInfo')
        .then((res) => {
            if(res.data.code=='200') {
                this.setuserToken(res.data.data.token)
                this.getLists(1)
                this.formUrl = `${this.commonIp()}/v1/userCard/list?export=1&token=${this.getuserToken()}&poiId=${this.$route.query.poiId}`
            }else if(res.data.code == '424'||res.data.code == '423'){
                if (this.isAndroid() || this.isIos()) {
                    window.location.href = "app://login";
                } else {
                    // lng=116.467125&lat=39.996747
                    window.location.href = `${this.commonIp()}/quickLogin?referer=${encodeURIComponent(window.location.href)}`;
                }
            }
        })
    },
    methods:{
        // 回首页
        goIndex() {
            this.$router.push(`/mcenter?poiId=${this.$route.query.poiId}`)
        },
        // 进入添加
        intoaddMsg() {
            this.$router.push({path:`/addmsg?poiId=${this.$route.query.poiId}&glmsk=1`})
        },
        reportTable() {
            let ua = navigator.userAgent.toLowerCase();
            if(ua.match(/MicroMessenger/i)=="micromessenger") {
                this.showMask = true
            } else {
                this.$refs.tbForm.submit()
                this.showMask = false
            }
        },
        closeMask() {
            this.showMask = false
        },
        intoDetail(openId,id) {
                this.$router.push({path:`/xxdetail?poiId=${this.$route.query.poiId}&openId=${openId}&id=${id}`})
        },
        getLists(status) {
            axios.post(this.commonIp()+'/v1/userCard/list',{
                token:this.getuserToken(),
                // page:1,
                keyword:this.keyword.trim(),
                poiId:this.$route.query.poiId,
                status:status
            }).then((res) => {
                if(res.data.code == '200') {
                    if(res.data.data.userCards.length==0) {
                        this.noShow = true
                    }else{
                        this.lists = res.data.data.userCards
                    }
                    this.len1 = res.data.data.status_1
                    this.len2 = res.data.data.status_2
                    this.len3 = res.data.data.status_0
                }else{ 
                    Toast(res.data.message)
                }
            })
        },
        goBack() {
            this.$router.go(-1)
            // this.$router.push({path:`/mcenter?poiId=${this.$route.query.poiId}`})
        },
        searchVal(e) {
            if(!e) e = window.event;
            if(e.keyCode ==13){
                this.keyword = e.target.value
                if(this.keyword.trim()) {
                    this.lists = []
                    this.getLists(this.isnum)
                }else{
                    Toast('请输入搜索内容')
                }
               
                this.$refs.keyIpt.blur()
            }
        },
        // 切换筛选
        changeStatus(val) {
            this.lists = []
            if(val == 1) {
                this.isnum = 1
                this.getLists(1)
            }else if(val == 2) {
                this.isnum = 2
                this.getLists(2)
            }else {
                this.isnum = 3
                this.getLists('')
            }
        }
    }
}
</script>
<style lang="less">
    @import "~@/assets/less/index.less";
    #records{
        .mint-button-text{
            color:#fff;
        }
        .setFix{
            height: 130px;
        }
        .btmBox{
            .btBtn{
                background:#aeaeae;
                padding:0 6px;
                text-align: center;
                &.mint-button-text{
                    color:#fff;
                }
                &.active{
                    background:#337ab7;
                }
            }
        }
        .addGlbtn{
            color:#000;
        }
        .subBtn{
            border:0;
            background:0;
            outline: none;
        }
        .selectBox{
            .select-item{
                text-align: center;
                outline: none;
                div{
                    width: 50%;
                    .fl();
                    select{
                        height:50px;
                        border:0;
                    }
                }
            }
        }
        .inputBox{
            width: 100%;
            background: #fff;
            position: fixed;
            height: 50px;
            top:42px;
        }
        .ipt{
            position: fixed;
            width: 86%;
            margin:10px 0 0 7%;
            border:1px solid #d8d8d8;
            background-image:url('~@/assets/imgs/s2.png');
            background-repeat: no-repeat;
            background-position: 10px center;
            background-color:#f2f2f2;
            background-size:13px;
            padding-left:32px;
            height:29px;
            outline: none;
            border-radius:4px;
            box-sizing: border-box;
            top:80px;
        }
        .listBox{
            .ttsearchBox{
                width:100%;
                position: fixed;
                top:80px;
                background: #fff;
            }
            .item-list{
                padding:15px;
                border-bottom:1px solid #d8d8d8;
                .top{
                    display: flex;
                    margin:0 0 10px 0;
                    .left{
                        width:160px;
                        flex:0 0 160px;
                    }
                    .right{
                        flex:1;
                        text-align: right;
                    }
                }
                .btm{
                    line-height: 26px;
                    height: 26px;
                    .sstate{
                        display: inline-block;
                        padding:0 6px;
                        line-height: 26px;
                        background:orange;
                        font-size:@ft14;
                        color:#fff;
                        .fr();
                        text-align: center;
                        border-radius:5px;
                        &.astate{
                            background:#25cf8d;
                        }
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/records/records.vue